import styled from '@emotion/styled';
import { css_gap, css_letter, css_stroke } from '~/emotion/theme';

const Header = styled.div<{ align?: 'start' | 'end' }>`
	display: flex;
	align-items: center;
	justify-content: ${({ align = 'start' }) => (align === 'end' ? 'flex-end' : 'flex-start')};
	gap: ${css_gap()};
	margin-bottom: ${css_gap('section', 2)};
`;

const Title = styled.h2`
	margin: 0;
	text-transform: uppercase;
	letter-spacing: ${css_letter('lg')};
	font-size: 0.75rem;
	font-weight: 700;
`;

const Rule = styled.div`
	width: 3rem;
	height: 1px;
	background: ${css_stroke()};
`;

interface BetaSectionHeaderProps {
	align?: 'start' | 'end';
	title: string;
	titleFirst?: boolean;
}

export default function BetaSectionHeader({ align, title, titleFirst = false }: BetaSectionHeaderProps) {
	return (
		<Header align={align}>
			{titleFirst ? (
				<>
					<Title>{title}</Title>
					<Rule />
				</>
			) : (
				<>
					<Rule />
					<Title>{title}</Title>
				</>
			)}
		</Header>
	);
}
